import { Directive, HostListener, HostBinding, Output, EventEmitter, Input } from '@angular/core';
var AmdInputDirective = /** @class */ (function () {
    function AmdInputDirective() {
        this.isFocussedChange = new EventEmitter();
        this.inputClass = true;
        this.inputFocussedClass = false;
        this._isFocussed = false;
    }
    Object.defineProperty(AmdInputDirective.prototype, "isFocussed", {
        /**
         * @param {?} isFocussed
         * @return {?}
         */
        set: function (isFocussed) {
            this.setFocus(isFocussed);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AmdInputDirective.prototype.onFocus = function () {
        this.setFocus(true);
    };
    /**
     * @return {?}
     */
    AmdInputDirective.prototype.onBlur = function () {
        this.setFocus(false);
    };
    /**
     * @param {?} focus
     * @return {?}
     */
    AmdInputDirective.prototype.setFocus = function (focus) {
        this._isFocussed = focus;
        this.inputFocussedClass = focus;
        this.isFocussedChange.emit(focus);
        // this.changeDetectorRef.markForCheck();
    };
    AmdInputDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[amdInput]'
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdInputDirective.ctorParameters = function () { return []; };
    AmdInputDirective.propDecorators = {
        'isFocussedChange': [{ type: Output },],
        'inputClass': [{ type: HostBinding, args: ['class.amd-input',] },],
        'inputFocussedClass': [{ type: HostBinding, args: ['class.amd-input--focussed',] },],
        'isFocussed': [{ type: Input },],
        'onFocus': [{ type: HostListener, args: ['focus',] },],
        'onBlur': [{ type: HostListener, args: ['blur',] },],
    };
    return AmdInputDirective;
}());
export { AmdInputDirective };
function AmdInputDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdInputDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdInputDirective.ctorParameters;
    /** @type {?} */
    AmdInputDirective.propDecorators;
    /** @type {?} */
    AmdInputDirective.prototype.isFocussedChange;
    /** @type {?} */
    AmdInputDirective.prototype.inputClass;
    /** @type {?} */
    AmdInputDirective.prototype.inputFocussedClass;
    /** @type {?} */
    AmdInputDirective.prototype._isFocussed;
}
//# sourceMappingURL=input.directive.js.map
//# sourceMappingURL=input.directive.js.map
